import React from 'react';

interface CurrencyFieldProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
}

export const formatCurrencyDisplay = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) return '';
  return value.toString();
};

export const CurrencyField: React.FC<CurrencyFieldProps> = ({
  label,
  value,
  onChange,
  disabled = false,
}) => (
  <div>
    <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
    <div className="relative">
      <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-sm text-gray-500">
        $
      </span>
      <input
        type="number"
        min={0}
        step="0.01"
        disabled={disabled}
        value={formatCurrencyDisplay(value)}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === '' ? null : parseFloat(v));
        }}
        className="block w-full rounded-xl border-gray-200 bg-white pl-7 pr-3 py-2.5 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500 disabled:bg-gray-50"
        inputMode="decimal"
      />
    </div>
  </div>
);
